<template>
  <div>
    <div class="row mb-3">
      <div class="col-md pt-2">
        <input class="form-control" placeholder="Search..."
               v-model="searchTerm"
               v-on:keyup="changeSearchBox" />
      </div>

    <department-list-data
                          v-on:change:deptfilter="changeDeptDataFilter"
                          v-bind:department-data="departmentData"
                          v-bind:hide-dept-picker="hideDeptPicker"
                          v-bind:initial-dept="dept.code"
                          v-bind:initial-sub-cat="subCat"></department-list-data>

      <!--<div class="col-md pt-2">
        <department-list v-on:change:deptfilter="changeDeptFilter" v-bind:initial="dept"/>
      </div>-->
      <div class="col-md pt-2">
        <title-list v-on:change:titlefilter="changeTitleFilter" v-bind:initial="title" />
      </div>
      <div class="col-md pt-2">
        <category-list v-on:change:categoryfilter="changeCategoryFilter" v-bind:initial="category" />
      </div>

    </div>
    <div class="row">
      <div class="col">
          <nav aria-label="Page navigation">
              <ul class="pagination justify-content-center">
                  <li class="page-item"><button class="page-link" aria-label="First Page" v-on:click="firstPage"><i class="fas fa-step-backward"></i></button></li>
                  <li class="page-item"><button class="page-link" aria-label="Back one page" v-on:click="previousPage"><i class="fas fa-backward"></i></button></li>
                  <li class="page-item px-1">
                      <label for="page-top" class="sr-only">Page Number</label>
                      <input type="number" class="form-control px-1"
                             v-model.number="currentPage"
                             v-on:change="changePageModel"
                             min="1" v-bind:max="peopleList.totalPages"
                             id="page-top">
                  </li>
                  <li class="page-item"><button class="page-link px-1" disabled>of {{peopleList.totalPages}}</button></li>
                  <li class="page-item"><button class="page-link" aria-label="Forward one page" v-on:click="nextPage"><i class="fas fa-forward"></i></button></li>
                  <li class="page-item"><button class="page-link" aria-label="Last page" v-on:click="lastPage"><i class="fas fa-step-forward"></i></button></li>
                  <li class="page-item" v-if="!hideDeptPicker"><button class="page-link" aria-label="Reset Filters" v-on:click="clearFilters"><i class="fas fa-undo"></i></button></li>
                  <li class="page-item" v-if="hideDeptPicker"><button class="page-link" aria-label="Reset Filters" v-on:click="clearFiltersDept"><i class="fas fa-undo"></i></button></li>
              </ul>
          </nav>

      </div>
    </div>

    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 list">
      <directory-person v-for="person in peopleList.results"
                        v-bind:person="person"
                        v-bind:key="person.id" />
    </div>

    <div class="row">
        <div class="col">
            <nav aria-label="Page navigation">
                <ul class="pagination justify-content-center">
                    <li class="page-item"><button class="page-link" aria-label="First Page" v-on:click="firstPage"><i class="fas fa-step-backward"></i></button></li>
                    <li class="page-item"><button class="page-link" aria-label="Back one page" v-on:click="previousPage"><i class="fas fa-backward"></i></button></li>
                    <li class="page-item px-1">
                        <label for="page-bottom" class="sr-only">Page Number</label>
                        <input type="number" class="form-control px-1"
                               v-model.number="currentPage"
                               v-on:change="changePageModel"
                               min="1" v-bind:max="peopleList.totalPages"
                               id="page-bottom">
                    </li>
                    <li class="page-item"><button class="page-link px-1" disabled>of {{peopleList.totalPages}}</button></li>
                    <li class="page-item"><button class="page-link" aria-label="Forward one page" v-on:click="nextPage"><i class="fas fa-forward"></i></button></li>
                    <li class="page-item"><button class="page-link" aria-label="Last page" v-on:click="lastPage"><i class="fas fa-step-forward"></i></button></li>
                </ul>
            </nav>
        </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import CategoryList from './CategoryList.vue'
  import DepartmentListData from './DepartmentListData.vue'
  import TitleList from './TitleList.vue'
  import DirectoryPerson from './DirectoryPerson.vue'
  import { track, trackSearch } from '../tracking.js'

  const baseInsensitive = { sensitivity: 'base' };

  export default {
    props: ['people'],
    components: {
      'category-list': CategoryList,
      'department-list-data': DepartmentListData,
      'title-list': TitleList,
      'directory-person': DirectoryPerson
    },
    data: function () {
      return {
        currentPage: 1,
        searchTerm: '',
        title: '',
        category: '',
        dept: '',
        subCat: '',
        peopleList: {},
        departmentData: {},
        testingDept: window.testingDept,
        hideDeptPicker: window.hideDeptPicker
      };
    },
    methods: {
      getDirectory: function () {
        return axios.get('/umbraco/api/Directory/GetDepartmentList');
      },
      fetchPeople: function () {
        // Cancel any in-flight fetch so a slower previous response can't
        // overwrite the freshest one.
        if (this.$_inflightFetch) this.$_inflightFetch.abort();
        const controller = new AbortController();
        this.$_inflightFetch = controller;

        return axios.get('/umbraco/api/Directory/GetPeople', {
          params: {
            page: this.currentPage,
            title: this.title ? this.title.title : undefined,
            category: this.category ? this.category.name : undefined,
            subCategory: this.subCat || undefined,
            name: this.searchTerm || undefined,
            dept: this.dept ? this.dept.code : undefined
          },
          signal: controller.signal
        }).then(response => {
          if (this.$_inflightFetch === controller) {
            this.peopleList = response.data;
            this.$_inflightFetch = null;
          }
        }).catch(err => {
          if (axios.isCancel(err)) return;
          throw err;
        });
      },
      writeUrl: function () {
        const queryObj = {};
        if (this.currentPage != 1) queryObj.page = this.currentPage;
        if (this.dept) queryObj.dept = this.dept.code;
        if (this.subCat) queryObj.subCat = this.subCat;
        if (this.title) queryObj.title = this.title.title;
        if (this.category) queryObj.category = this.category.name;
        if (this.searchTerm) queryObj.searchTerm = this.searchTerm;
        this.$router.push({ query: queryObj });
      },
      previousPage: function () {
        const fromPage = this.currentPage;
        this.currentPage = Math.max(1, this.currentPage - 1);
        track('pagination', {
          paging_action: 'prev',
          from_page: fromPage,
          to_page: this.currentPage,
          total_pages: this.peopleList.totalPages || null
        });
        this.writeUrl();
      },
      nextPage: function () {
        const max = this.peopleList.totalPages || 1;
        const fromPage = this.currentPage;
        this.currentPage = Math.min(max, this.currentPage + 1);
        track('pagination', {
          paging_action: 'next',
          from_page: fromPage,
          to_page: this.currentPage,
          total_pages: this.peopleList.totalPages || null
        });
        this.writeUrl();
      },
      firstPage: function () {
        const fromPage = this.currentPage;
        this.currentPage = 1;
        track('pagination', {
          paging_action: 'first',
          from_page: fromPage,
          to_page: this.currentPage,
          total_pages: this.peopleList.totalPages || null
        });
        this.writeUrl();
      },
      lastPage: function () {
        const fromPage = this.currentPage;
        this.currentPage = this.peopleList.totalPages || 1;
        track('pagination', {
          paging_action: 'last',
          from_page: fromPage,
          to_page: this.currentPage,
          total_pages: this.peopleList.totalPages || null
        });
        this.writeUrl();
      },
      changePageModel: function () {
        const max = this.peopleList.totalPages || 1;
        if (this.currentPage > max) this.currentPage = max;
        if (this.currentPage < 1) this.currentPage = 1;
        // v-model.number has already mutated currentPage before this handler
        // fires, so we don't have the pre-jump page; track only the destination.
        track('pagination', {
          paging_action: 'jump',
          to_page: this.currentPage,
          total_pages: this.peopleList.totalPages || null
        });
        this.writeUrl();
      },
      changeDeptDataFilter: function (blob) {
        const prevDeptCode = this.dept ? this.dept.code : null;
        const prevSubCat = this.subCat || null;
        this.dept = blob.dept || '';
        this.subCat = blob.subCat || '';
        this.currentPage = 1;
        const newDeptCode = this.dept ? this.dept.code : null;
        const newSubCat = this.subCat || null;
        if (prevDeptCode !== newDeptCode) {
          track('filter_change', { filter_type: 'department', filter_value: newDeptCode });
        }
        if (prevSubCat !== newSubCat) {
          track('filter_change', { filter_type: 'subcategory', filter_value: newSubCat });
        }
        this.writeUrl();
      },
      changeTitleFilter: function (title) {
        this.title = title || '';
        this.currentPage = 1;
        track('filter_change', {
          filter_type: 'title',
          filter_value: this.title ? this.title.title : null
        });
        this.writeUrl();
      },
      changeCategoryFilter: function (category) {
        this.category = category || '';
        this.currentPage = 1;
        track('filter_change', {
          filter_type: 'category',
          filter_value: this.category ? this.category.name : null
        });
        this.writeUrl();
      },
      changeSearchBox: function () {
        this.currentPage = 1;
        trackSearch(this.searchTerm);
        this.writeUrl();
      },
      clearFilters: function () {
        track('reset_filters', { reset_type: 'all' });
        this.$router.push({ query: {} });
      },
      clearFiltersDept: function () {
        // Preserve dept (testingDept will reapply it anyway on sub-pages).
        track('reset_filters', { reset_type: 'preserve_dept' });
        const q = {};
        if (this.dept) q.dept = this.dept.code;
        this.$router.push({ query: q });
      }
    },
    watch: {
      '$route': {
        immediate: true,
        handler() {
          const q = this.$route.query;

          this.currentPage = q.page ? parseInt(q.page) : 1;

          // testingDept (hidden filter on sub-pages) wins over URL param.
          const deptCode = this.testingDept || q.dept;
          this.dept = deptCode
            ? (window.allList.find(d => d.code.localeCompare(deptCode, 'en', baseInsensitive) === 0) || '')
            : '';

          this.subCat = q.subCat || '';

          this.title = q.title
            ? (window.titleList.find(t => t.title.localeCompare(q.title, 'en', baseInsensitive) === 0) || '')
            : '';

          this.category = q.category
            ? (window.categoryList.find(c => c.name.localeCompare(q.category, 'en', baseInsensitive) === 0) || '')
            : '';

          this.searchTerm = q.searchTerm || '';

          this.fetchPeople();
        }
      }
    },
    mounted: function () {
      this.getDirectory().then(response => { this.departmentData = response.data; });
    }
  }
</script>
